import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { AuthModule, AuthHttpInterceptor, authHttpInterceptorFn } from '@auth0/auth0-angular';
import { environment } from 'src/environments/environment';
import { ServiceWorkerModule } from '@angular/service-worker';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { provideHttpClient, withInterceptors, withNoXsrfProtection } from '@angular/common/http';

@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    MatSnackBarModule,
    AppRoutingModule,
     AuthModule.forRoot({
      domain   : 'auth.sprinta.io',   
      clientId : 'bkjMMCUc3aNn2U7zhok6oLwnJOu9cUsz', 
      authorizationParams: {
        redirect_uri : environment.auth_redirect_uri,
        audience     : 'https://api.sprinta.io',
      },
      httpInterceptor: {
        allowedList: [
          {
            uriMatcher: (uri: string) => !uri.includes('/health') && (uri.startsWith('https://api.sprinta.io/v1/') || uri.startsWith('https://api.sprinta.io/')),
            tokenOptions: {
              authorizationParams: {
                audience: 'https://api.sprinta.io',
              }
            },
            allowAnonymous: true
          }
        ]
      },
      useRefreshTokens: true     
    }),
     ServiceWorkerModule.register('/ngsw-worker.js', {
       enabled              : environment.production,
       registrationStrategy : 'registerWhenStable:3000'
     })
  ],
  providers: [
    AuthHttpInterceptor,
    provideHttpClient(
      withInterceptors([authHttpInterceptorFn]),
      withNoXsrfProtection()
    )
  ],
  exports  : [
    AppRoutingModule
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
